import { render } from "./AvatarWheel.vue?vue&type=template&id=09bd34ff"
import script from "./AvatarWheel.vue?vue&type=script&lang=js"
export * from "./AvatarWheel.vue?vue&type=script&lang=js"
script.render = render

export default script